<template>
<div class="lvImgTextItemBox">
  <div v-if="text!=''">
    <!--  日期-->
    <div class="itemDate">{{ itemDate }}</div>
    <!--  时间-->
    <div class="itemTime"><pre>{{ itemTime }}</pre></div>
    <!--  文字-->
    <div class="itemText"><pre>{{ text }}</pre></div>
    <!--  图片-->
    <div class="itemImg" v-if="imgUrl!=''">
      <img style="max-width: 50%; " :src="imgUrl" alt="img" @click="showImg">
<!--      <van-image-->
<!--          width="auto"-->
<!--          height="10rem"-->
<!--          fit="scale-down"-->
<!--          position="left"-->
<!--          lazy-load-->
<!--          :src="imgUrl"-->
<!--          @click="showImg"-->
<!--      />-->
    </div>
  </div>
</div>

</template>

<script>

import {utils} from "../../../network/utils";
import {ImagePreview} from "vant";

export default {
  name: "lvImgTextItem",
  props: {
    isAction: {
      type: Boolean,
      default: false,
    },
    time: {
      type: Number,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    imgUrl: {
      type: String,
      required: true
    },
  },
  computed:{
    itemDate(){
      return utils.date('Y年m月d日', this.time)
    },
    itemTime(){
      return utils.date('H:i', this.time)
    }
  },

  data(){
    return {

    }
  },
  methods:{
    showImg(){
      let obj = [];
      obj[0] = this.imgUrl
      console.log('show img')
      ImagePreview({
        images: obj,
        startPosition: 0,
        closeable: true,
      })
    }
  }
}
</script>

<style scoped>
.lvImgTextItemBox{
  margin-top: 60px;
  margin-left: 45px;
  width: 990px;
  color: #30353d;
  font-size: 32px;
  /*border-bottom: 1px solid #e5e3e3;*/
}
.itemDate{
  color: #b4b4b4;
}
.itemTime{
  margin-top: 12px;
  margin-left: -45px;
  padding-left: 45px;
  font-weight: bolder;
  color: red;
  font-size: 35px;
  background-image: url("../../../assets/live/point.png");
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-position: 20px center;
  /*background-color: #07c160;*/
}
.itemText{
  color: black;
  margin-top: 20px;
  font-size: 40px;
  /*background-color: #07c160;*/
}

.itemImg{
  margin-top: 20px;
  min-width: 100px;
  min-height: 100px;
}
</style>